import { z } from 'zod';
import { InputJsonValue } from "../inputTypeSchemas/InputJsonValue"
import { ProductTypeSchema } from '../inputTypeSchemas/ProductTypeSchema'
import { DataIntegrationTypeSchema } from '../inputTypeSchemas/DataIntegrationTypeSchema'
import { DataSyncExternalRecordTypeSchema } from '../inputTypeSchemas/DataSyncExternalRecordTypeSchema'
import { DataIntegrationSyncingFrequencySchema } from '../inputTypeSchemas/DataIntegrationSyncingFrequencySchema'
import { DataIntegrationPollingFrequencySchema } from '../inputTypeSchemas/DataIntegrationPollingFrequencySchema'
import { AuthTypeSchema } from '../inputTypeSchemas/AuthTypeSchema'

/////////////////////////////////////////
// CORE INTEGRATION DATA SYNC SETTING SCHEMA
/////////////////////////////////////////

export const CoreIntegrationDataSyncSettingSchema = z.object({
  productType: ProductTypeSchema,
  integrationType: DataIntegrationTypeSchema,
  externalRecordType: DataSyncExternalRecordTypeSchema,
  syncingFrequency: DataIntegrationSyncingFrequencySchema,
  pollingFrequency: DataIntegrationPollingFrequencySchema,
  authType: AuthTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  enabledAt: z.coerce.date().nullable(),
  name: z.string(),
  serverUrl: z.string(),
  authUser: z.string().nullable(),
  authPasswordEncrypted: z.string().nullable(),
  apiKey: z.string().nullable(),
  maxRequestsPerMinute: z.number().int().nullable(),
  maxRecordsPerRequest: z.number().int().nullable(),
  adminContactEmails: InputJsonValue,
  adminNotes: z.string().nullable(),
  mainFilterGroupId: z.number().int().nullable(),
  manualFilterGroupId: z.number().int().nullable(),
  portalUrl: z.string().nullable(),
  syncingWorkerLastRanAt: z.coerce.date().nullable(),
  pollingWorkerLastRanAt: z.coerce.date().nullable(),
  syncingWorkerLastErroredAt: z.coerce.date().nullable(),
  pollingWorkerLastErroredAt: z.coerce.date().nullable(),
  webhookHash: z.string().nullable(),
  dynamicExternalRecordType: z.string().nullable(),
})

export type CoreIntegrationDataSyncSetting = z.infer<typeof CoreIntegrationDataSyncSettingSchema>

export default CoreIntegrationDataSyncSettingSchema;
